var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomVacation = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.693 10.876a5.515 5.515 0 0 0-1.212-.139c-2.877 0-5.218 2.208-5.218 4.922 0 .551.1 1.1.3 1.633a.467.467 0 0 0 .447.299.488.488 0 0 0 .353-.148A4.353 4.353 0 0 1 7.627 16.2a7.604 7.604 0 0 1 3.066-5.324zM7.387 19.46c-1.135.748-1.838 1.959-1.838 3.288 0 .46.095.932.285 1.403.052.13.167.232.311.273a.524.524 0 0 0 .425-.062c.837-.544 2.044-.838 2.837-.983a11.33 11.33 0 0 1-2.02-3.92zM15.195 9.308c1.154 0 2.242.295 3.215.806V8.38c0-1.792-1.443-3.25-3.215-3.25-1.773 0-3.216 1.458-3.216 3.25v1.734a6.884 6.884 0 0 1 3.216-.806zM20.265 10.737c-.414 0-.818.05-1.212.139A7.604 7.604 0 0 1 22.12 16.2c.863.18 1.66.61 2.264 1.243a.488.488 0 0 0 .445.14.467.467 0 0 0 .355-.291c.199-.532.3-1.082.3-1.633 0-2.714-2.342-4.922-5.22-4.922zM22.358 19.46a11.341 11.341 0 0 1-2.019 3.918c.794.145 2 .44 2.837.984a.512.512 0 0 0 .425.062.472.472 0 0 0 .312-.273c.189-.472.284-.944.284-1.404 0-1.328-.703-2.538-1.839-3.287z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.121 16.986c0-3.795 3.023-6.872 6.752-6.872 3.73 0 6.752 3.077 6.752 6.872s-3.023 8.704-6.752 8.704c-3.729 0-6.752-4.909-6.752-8.704z",
    fill: "#1E2969"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomVacation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-vacation.e7f9089c386123ff2f4f0d5f046f12cb.svg";